import React from 'react';

const SalesDealerSettlement = () => {

    const thisYear = new Date().getYear() + 1900;
    const thisMonth = new Date().getMonth() + 1;
    const thisDate = new Date().getDate();

    const today = thisYear + "-" + thisMonth + "-" + thisDate;

    console.log(today);

    const selectDate = () => {
        console.log("test");
    }


    return (
        <>
{/*}
        <div className="row">

          <div className="card">
            <div className="card-body">
              <h5 className="card-title">daily sales graph - dealer</h5>

                  <div id="reportsChart"></div>

                  <script>
                    document.addEventListener("DOMContentLoaded", () => {
                      new ApexCharts(document.querySelector("#reportsChart"), {
                        series: [{
                          name: '판매수량',
                          data: [31, 40, 28, 51, 42, 82, 56],
                        }, {
                          name: '판매금액',
                          data: [11, 32, 45, 32, 34, 52, 41]
                        }, {
                          name: '주문고객',
                          data: [15, 11, 32, 18, 9, 24, 11]
                        }],
                        chart: {
                          height: 300,
                          type: 'area',
                          toolbar: {
                            show: false
                          },
                        },
                        markers: {
                          size: 4
                        },
                        colors: ['#4154f1', '#2eca6a', '#ff771d'],
                        fill: {
                          type: "gradient",
                          gradient: {
                            shadeIntensity: 1,
                            opacityFrom: 0.3,
                            opacityTo: 0.4,
                            stops: [0, 90, 100]
                          }
                        },
                        dataLabels: {
                          enabled: false
                        },
                        stroke: {
                          curve: 'smooth',
                          width: 2
                        },
                        xaxis: {
                          type: 'date',
                          categories: ["09-19", "09-20", "09-21", "09-22", "09-23", "09-24", "09-25"]
                        },
                        tooltip: {
                          x: {
                            format: 'MM/yy'
                          },
                        }
                      }).render();
                    });
                  </script>

              </div>
            </div>



      </div>
*/}
      <div className="row">



        {/*<div className="col-lg-6">*/}
        <div>

          <div className="card">
            <div className="card-body">
              <h5 className="card-title">daily sales list</h5>


              <div className="row">
                <div className="col-sm-3">
                  <input type="date" className="form-control" defaultValue="2024-10-12" />
                </div>
                <div className="col-sm-1">
                  ~
                </div>
                <div className="col-sm-3">
                  <input type="date" className="form-control" defaultValue="2024-10-14" />
                </div>
                <div className="col-sm-3">
                  <input type="text" className="form-control" defaultValue="딜러명" />
                </div>                   
                <div className="col-sm-2">
                  <button type="button" className="btn btn-primary">적용</button>
                </div>
              </div>

              <div style={{marginTop: "20px"}}>&nbsp;</div>

              <table className="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">date</th>
                    <th scope="col">판매금액</th>
                    <th scope="col">판매수량</th>
                    <th scope="col">종류</th>
                    <th scope="col">정산금</th>
                    <th scope="col">자세히</th>
                  </tr>
                </thead>
                <tbody>


                  <tr>
                    <td>2024-10-12(<font color="blue">土</font>)</td>
                    <td>100,000</td>
                    <td>5</td>
                    <td>5</td>
                    <td>80,000</td>
                    <td><button type="button" className="btn btn-primary btn-sm">보기</button></td>
          
                  </tr>

                  <tr>
                    <td>2024-10-13(<font color="red">日</font>)</td>
                    <td>100,000</td>
                    <td>5</td>
                    <td>5</td>
                    <td>80,000</td>
                    <td><button type="button" className="btn btn-primary btn-sm">보기</button></td>
                  </tr>

                  <tr>
                    <td>2024-10-14(月)</td>
                    <td>100,000</td>
                    <td>5</td>
                    <td>5</td>
                    <td>80,000</td>
                    <td><button type="button" className="btn btn-primary btn-sm">보기</button></td>
                  </tr>

                  <tr>
                    <td>2024-10-15(火)</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td><button type="button" className="btn btn-primary btn-sm" disabled>보기</button></td>
                  </tr>
                  <tr>
                    <td>2024-10-16(水)</td>
                    <td>100,000</td>
                    <td>5</td>
                    <td>5</td>
                    <td>80,000</td>
                    <td><button type="button" className="btn btn-primary btn-sm">보기</button></td>
                  </tr>
                  <tr>
                    <td>2024-10-17(木)</td>
                    <td>100,000</td>
                    <td>5</td>
                    <td>5</td>
                    <td>80,000</td>
                    <td><button type="button" className="btn btn-primary btn-sm">보기</button></td>
                  </tr>
                  <tr>
                    <td>2024-10-18(金)</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td><button type="button" className="btn btn-primary btn-sm" disabled>보기</button></td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>

        </div>


{/*
        <div className="col-lg-6">

          <div className="card">
            <div className="card-body">
              <h5 className="card-title">daily sales detail</h5>


              <div className="row">
                <div className="col-sm-12">
                왼쪽에서 자세히보기 누르면 요기에 세부내역 나옴
                </div>
              </div>


              <table className="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">time</th>
                    <th scope="col">상품명</th>
                    <th scope="col">판매금액</th>
                    <th scope="col">판매수량</th>
                    <th scope="col">구매자</th>
                  </tr>
                </thead>
                <tbody>

                  <tr>
                    <td>14:58</td>
                    <td>head conversion</td>
                    <td>2,000</td>
                    <td>2</td>
                    <td>makamaka</td>
                  </tr>

                  <tr>
                    <td>14:58</td>
                    <td>head conversion</td>
                    <td>2,000</td>
                    <td>2</td>
                    <td>makamaka</td>
                  </tr>

                  <tr>
                    <td>14:58</td>
                    <td>head conversion</td>
                    <td>2,000</td>
                    <td>2</td>
                    <td>makamaka</td>
                  </tr>

                  <tr>
                    <td>14:58</td>
                    <td>head conversion</td>
                    <td>2,000</td>
                    <td>2</td>
                    <td>makamaka</td>
                  </tr>


                </tbody>
              </table>

            </div>
          </div>

        </div>
*/}
      </div>
      </>
    );

}

export default SalesDealerSettlement;